import React, { Component } from "react";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import Avatar from "@material-ui/core/Avatar";
import Typography from "@material-ui/core/Typography";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import MotorcycleIcon from "@material-ui/icons/Motorcycle";
import { compareTime, timeConvert } from "../Branches/ContactPageTools";
import PaymentIcon from "@material-ui/icons/Payment";
import { Button } from "@material-ui/core";
import moment from "moment";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import instance from "../../store/actions/instance";

import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import InputBase from "@material-ui/core/InputBase";
import IconButton from "@material-ui/core/IconButton";
import SearchIcon from "@material-ui/icons/Search";
import ServiceTypeSelect from "../ServiceTypeSelect";
import { withRouter } from "react-router";
import Spacer from "./Spacer";
import CancelIcon from "@material-ui/icons/Cancel";
import AccessibleTwoToneIcon from "@material-ui/icons/AccessibleTwoTone";
import { ReactComponent as AttachMoneyIcon } from "./money.svg";
import ScheduleIcon from "@material-ui/icons/Schedule";
import { fetchDeliveryTime, setDrawer } from "../../store/actions/deliveryTime";
import { CircularProgress } from "@material-ui/core";
import Addresses from "../CheckoutProcess/Confirmation/Addresses";
import MenuBookIcon from "@material-ui/icons/MenuBook";
import LocalLibraryIcon from "@material-ui/icons/LocalLibrary";
import LocalParkingIcon from "@material-ui/icons/LocalParking";
import LocationOnIcon from "@material-ui/icons/LocationOn";
import RestaurantMenuIcon from "@material-ui/icons/RestaurantMenu";
import { SwipeableDrawer, Drawer } from "@material-ui/core";
import DeliveryTimeChange from "../CheckoutProcess/Confirmation/DeliveryTimeChange";
import { SettingsOutlined } from "@material-ui/icons";
import RoomServiceIcon from "@material-ui/icons/RoomService";
import MuiAlert from "@material-ui/lab/Alert";
import Snackbar from "@material-ui/core/Snackbar";
import Fab from "@material-ui/core/Fab";
import CallWaiterDialog from "../CallWaiterDialog";
import PreviousOrderAgain from "../PreviousOrderAgain";
import { getCurrencyIcon } from "../../Helpers/currencyConverter";
import { getSavedAddresses } from "../../Helpers/orderPass";

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = makeStyles((theme) => ({
  root: {
    padding: "2px 13px",
    display: "flex",
    alignItems: "center",
    borderRadius: 0,
    boxShadow: "none",
    borderBottom: "1px solid #dee2e6",
    borderTop: "1px solid #dee2e6",
  },
  input: {
    marginLeft: theme.spacing(1),
    flex: 1,
  },
  iconButton: {
    padding: 10,
  },
  divider: {
    height: 28,
    margin: 4,
  },
}));

class StoreInfo extends Component {
  state = {
    addressesDrawerOpen: false,
    isStoreBusy: false,
    alertOpen: false,
    callWaiterDialogOpen: false,
  };

  getSavedAddresses = () =>
    getSavedAddresses(
      { user: this.props.auth.user, addresses: this.props.auth.addresses },
      this.props.orderPassAddresses,
      this.props.settings,
    );

  openDeliveryAddressSelector = (event) => {
    const hasSavedAddresses = this.getSavedAddresses().length > 0;

    if (
      this.getIsDelivery() &&
      hasSavedAddresses &&
      !this.props.address?.parkingNumber
    ) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }
      this.setState({ addressesDrawerOpen: true });
      return true;
    }

    return false;
  };

  checkIfStoreIsBusy = () => {
    const { language, settings } = this.props;
    if (
      !settings.is_branch_based_ordering ||
      (settings.is_branch_based_ordering && this.props.branch.branch != null)
    ) {
      return !!(
        settings.show_busy_hour_warning &&
        settings.busy_until_active &&
        settings.busy_until_time &&
        settings.busy_until_date &&
        ((compareTime(settings.busy_until_time, moment().format("HH:mm:ss")) ===
          1 &&
          moment(settings.busy_until_date).format("YYYY-MM-DD") ===
            moment().format("YYYY-MM-DD")) ||
          moment(settings.busy_until_date).format("YYYY-MM-DD") >
            moment().format("YYYY-MM-DD"))
      );
    } else return false;
  };
  translateMonthArabic = (month) => {
    const ar_months = {
      January: "يناير",
      February: "فبراير",
      March: "مارس",
      April: "ابريل",
      May: "مايو",
      June: "يونيو",
      July: "يوليو",
      August: "اغسطس",
      September: "سبتمبر",
      October: "اكتوبر",
      November: "نوفمبر",
      December: "ديسمبر",
    };
    return ar_months[month];
  };

  renderIsolatedText = (text, direction = "ltr") => (
    <span dir={direction} style={{ unicodeBidi: "isolate" }}>
      {text}
    </span>
  );

  renderBusyTime = () =>
    this.renderIsolatedText(
      timeConvert(this.props.settings.busy_until_time, this.props.language),
    );

  renderBusyDuration = (hours, minutes) => {
    const { language } = this.props;

    if (language === "english") {
      if (hours > 0 && minutes > 0)
        return `${hours} hours and ${minutes} minutes`;
      if (hours > 0) return `${hours} hours`;
      if (minutes > 0) return `${minutes} minutes`;
      return "less than a minute";
    }

    if (hours > 0 && minutes > 0) {
      return (
        <>
          {this.renderIsolatedText(hours)} ساعة و{" "}
          {this.renderIsolatedText(minutes)} دقيقة
        </>
      );
    }
    if (hours > 0) {
      return <>{this.renderIsolatedText(hours)} ساعة</>;
    }
    if (minutes > 0) {
      return <>{this.renderIsolatedText(minutes)} دقيقة</>;
    }
    return "أقل من دقيقة";
  };

  renderBusyDate = (busyUntilDate) => {
    const { language } = this.props;

    if (language === "english") {
      return this.renderIsolatedText(busyUntilDate.format("ll"));
    }

    return (
      <span dir="rtl" style={{ unicodeBidi: "isolate" }}>
        {this.renderIsolatedText(busyUntilDate.format("DD"))}{" "}
        {this.translateMonthArabic(busyUntilDate.format("MMMM"))}
      </span>
    );
  };

  renderStoreIsBusy = () => {
    const { language, settings } = this.props;

    if (this.checkIfStoreIsBusy()) {
      let busyText;
      const busyUntilDate = moment(settings.busy_until_date);
      const busyUntilTime = moment(settings.busy_until_time, "HH:mm");
      const today = moment().startOf("day");
      const tomorrow = moment().startOf("day").add(1, "day");

      if (!settings.show_busy_until_time) {
        busyText =
          language === "english" ? `Store is busy` : `المتجر مغلق حالياً`;
      } else if (busyUntilDate.isSame(today, "day")) {
        const duration = moment.duration(busyUntilTime.diff(moment()));
        const hours = Math.floor(duration.asHours());
        const minutes = duration.minutes();
        const timeRemainingText = this.renderBusyDuration(hours, minutes);

        busyText =
          language === "english"
            ? `Reopening in ${timeRemainingText}`
            : <>سيتم فتح المتجر بعد {timeRemainingText}</>;
      } else if (busyUntilDate.isSame(tomorrow, "day")) {
        busyText =
          language === "english"
            ? `Reopening Tomorrow at ${timeConvert(
                settings.busy_until_time,
                language,
              )}`
            : <>سيتم فتح المتجر غدًا في {this.renderBusyTime()}</>;
      } else {
        busyText =
          language === "english" ? (
            <>
              Store is closed until {this.renderBusyDate(busyUntilDate)} -{" "}
              {this.renderBusyTime()}
            </>
          ) : (
            <>
              المتجر مغلق حتى {this.renderBusyDate(busyUntilDate)} -{" "}
              {this.renderBusyTime()}
            </>
          );
      }

      return (
        <div
          className={!settings.show_cover && "product-header-margin"}
          style={{
            backgroundColor: "red",
            minHeight: 34,
            lineHeight: "34px",
            color: "white",
            fontWeight: "bold",
            direction: language === "arabic" ? "rtl" : "ltr",
            textAlign: "center",
            unicodeBidi: "isolate",
            padding: "0 8px",
          }}
        >
          {busyText}
        </div>
      );
    } else {
      return null;
    }
  };

  renderMOV = () => {
    const { settings, language } = this.props;
    const currencyIcon = getCurrencyIcon(settings);
    if (
      !settings.is_branch_based_ordering ||
      (settings.is_branch_based_ordering &&
        this.props.branch.branch != null &&
        this.props.branch.isPickup != true &&
        !settings.is_menu)
    ) {
      if (settings.minimum_order > 0)
        return (
          <span>
            {language == "english" ? (
              <span>
                Min. order:
                <span
                  className={
                    ["SAR", "AED"].includes(settings?.currency_iso)
                      ? `${currencyIcon} ml-2`
                      : ""
                  }
                >
                  {settings?.minimum_order}
                  {settings?.currency_english}
                </span>
              </span>
            ) : (
              <span>
                الحد الأدنى:
                <span
                  className={
                    ["SAR", "AED"].includes(settings?.currency_iso)
                      ? `${currencyIcon} ml-2`
                      : ""
                  }
                >
                  {settings?.minimum_order}
                  {settings?.currency_local}
                </span>
              </span>
            )}
          </span>
        );
      else return null;
    }

    return null;
  };

  fetchEarliestDeliveryTime = () => {
    const { deliveryTime } = this.props;

    this.props.fetchDeliveryTime();
  };

  componentDidMount = () => {
    this.fetchEarliestDeliveryTime();
  };

  tDate = (date) => {
    const { language } = this.props;
    if (language === "english") return date;
    const months = {
      AM: "ص",
      PM: "م",

      "Jan,": "يناير،",
      "Feb,": "فبراير،",
      "Mar,": "مارس،",
      "Apr,": "ابريل،",
      "May,": "مايو،",
      "Jun,": "يونيو،",
      "Jul,": "يوليو،",
      "Aug,": "اغسطس،",
      "Sep,": "سبتمبر،",
      "Oct,": "اكتوبر،",
      "Nov,": "نوفمبر،",
      "Dec,": "ديسمبر،",
    };
    date = date
      .split(" ")
      .map((i) => months[i] || i)
      .join(" ");
    return date;
  };

  asapText = (within) => {
    const { language, settings, deliveryTime, has_preordering } = this.props;
    if (
      settings.enable_on_demand_custom_string &&
      !deliveryTime.isPickup &&
      !has_preordering
    )
      return language === "arabic"
        ? settings.on_demand_custom_string_ar
        : settings.on_demand_custom_string;
    if (
      settings.enable_on_demand_custom_string_pickup &&
      deliveryTime.isPickup &&
      !has_preordering
    )
      return language === "arabic"
        ? settings.on_demand_pickup_custom_string_ar
        : settings.on_demand_pickup_custom_string;
    if (within >= 1440) {
      const days = Math.floor(within / 1440);
      const hours = Math.floor((within - days * 1440) / 60);
      if (language == "english") return `${days} day${days > 1 ? "s" : ""}`;
      else return `${days} يوم`;
    } else if (within < 1440 && within > 720) {
      const tempMoment = moment(
        `${deliveryTime.expected_date} ${deliveryTime.expected_start}`,
        "YYYY-MM-DD HH:mm",
      );

      return language === "arabic"
        ? tempMoment.locale("ar").format("D MMM، h:mm A")
        : tempMoment.format("MMM D, h:mm A");
    } else if (within < 720 && within > 0) {
      // const hours = Math.round((within / 60) * 4) / 4;
      // const minutes = Math.floor(within - (hours >= 1 ? hours : 0) * 60);
      const hours = within / 60;
      const rhours = Math.floor(hours);
      const minutes = (hours - rhours) * 60;
      const rminutes = Math.round(minutes);
      if (language === "english") {
        let temp = "";
        if (hours >= 1) {
          temp = temp.concat(`${rhours} h`);
          if (rminutes > 0) temp = temp.concat(` ${rminutes} min`);
        } else if (minutes && hours < 1) temp = temp.concat(`${rminutes} min`);
        return temp;
      } else {
        let temp = "";
        if (hours >= 1) {
          temp = temp.concat(`${rhours} س `);
          if (rminutes > 0) temp = temp.concat(`${rminutes} دق `);
        } else if (minutes && hours < 1) temp = temp.concat(`${rminutes} دق `);

        return temp;
      }
    } else {
      if (language == "english") return `${within} minutes`;
      else return `${within} دقيقة`;
    }
  };

  getDeliveryTimeText = () => {
    const { deliveryTime, language } = this.props;

    if (
      deliveryTime.expected_date &&
      deliveryTime.expected_start &&
      deliveryTime.expected_end
    ) {
      if (deliveryTime.type === "asap" && deliveryTime.asap?.now) {
        return this.asapText(deliveryTime.asap.within);
      }

      const tempMoment = moment(
        `${deliveryTime.expected_date} ${deliveryTime.expected_start}`,
        "YYYY-MM-DD HH:mm",
      );

      const endMoment = moment(
        `${deliveryTime.expected_date} ${deliveryTime.expected_end}`,
        "YYYY-MM-DD HH:mm",
      );

      if (
        moment().add(1, "days").format("YYYY-MM-DD") ===
        tempMoment.format("YYYY-MM-DD")
      ) {
        return (
          (language === "arabic" ? "غدا " : "Tomorrow ") +
          this.tDate(tempMoment.format("h:mm A")) +
          " - " +
          this.tDate(endMoment.format("h:mm A"))
        );
      } else
        return (
          this.tDate(tempMoment.format("D MMM, h:mm A")) +
          (language === "arabic" ? " الى " : " to ") +
          this.tDate(endMoment.format("h:mm A"))
        );
    }

    if (!!deliveryTime.asap) {
      if (deliveryTime.asap.now) return this.asapText(deliveryTime.asap.within);
      else {
        const tempMoment = moment(
          `${deliveryTime.asap.date} ${deliveryTime.asap.start}`,
          "YYYY-MM-DD HH:mm",
        );
        const endMoment = moment(
          `${deliveryTime.asap.date} ${deliveryTime.asap.end}`,
          "YYYY-MM-DD HH:mm",
        );
        if (
          moment().add(1, "days").format("YYYY-MM-DD") ===
          tempMoment.format("YYYY-MM-DD")
        ) {
          return (
            (language === "arabic" ? "غدا " : "Tomorrow ") +
            this.tDate(tempMoment.format("h:mm A")) +
            " - " +
            this.tDate(endMoment.format("h:mm A"))
          );
        } else
          return (
            this.tDate(tempMoment.format("D MMM, h:mm A")) +
            " to " +
            this.tDate(endMoment.format("h:mm A"))
          );
      }
    } else if (!!deliveryTime.scheduled || !!deliveryTime.pickup) {
      let activeSlot = "";
      let data = deliveryTime.scheduled || deliveryTime.pickup;
      let keys = Object.keys(data || data);
      for (let i = 0; i < keys.length; i++) {
        if (data[keys[i]].active) {
          activeSlot = `${keys[i]} ${data[keys[i]]["slots"][0]["start"]}`;
          break;
        }
      }
      if (activeSlot) {
        const tempMoment = moment(activeSlot, "YYYY-MM-DD HH:mm");
        if (
          moment().add(1, "days").format("YYYY-MM-DD") ===
          tempMoment.format("YYYY-MM-DD")
        ) {
          return (
            (language === "arabic" ? "غدا " : "Tomorrow ") +
            (language === "arabic"
              ? this.tDate(tempMoment.locale("ar").format("D MMM، h:mm A"))
              : this.tDate(tempMoment.format("h:mm A")))
          );
        } else {
          if (language === "arabic")
            return this.tDate(tempMoment.locale("ar").format("D MMM، h:mm A"));
          else return this.tDate(tempMoment.format("D MMM, h:mm A"));
        }
      }
    }
  };

  getIsDelivery = () => {
    const {
      settings,
      branch,
      address,
      language,
      branches,
      branch_delivery_charges,
      allow_only_pickup,
    } = this.props;

    if (settings.is_branch_based_ordering) {
      if (
        !branch.isPickup &&
        (settings.enable_delivery || settings.enable_delivery_select) &&
        !allow_only_pickup
      )
        return true;
    } else {
      if (!address && settings.enable_delivery) return true;
      if (address?.selectedDeliveryType === 0) return true;
    }
    return false;
  };

  nonAsapText = () => {
    const { expected_start, expected_date, expected_end, today_date } =
      this.props.deliveryTime;
    const { language, customTexts, settings } = this.props;
    const format = settings.military_delivery_time ? "HH:mm" : "h:mm A";
    let date;
    if (expected_date != moment().format("YYYY-MM-DD")) {
      if (moment(expected_date, "YYYY-MM-DD").year() > moment().year()) {
        date = moment(expected_date, "YYYY-MM-DD").format("ddd MMM DD Y");
      } else {
        date = moment(expected_date, "YYYY-MM-DD").format("ddd MMM DD");
      }
    } else date = "Today";
    let start = moment(expected_start, "HH:mm").format(format);
    let end = moment(expected_end, "HH:mm").format(format);
    let finalDateString;
    if (start == end) {
      finalDateString = `${date} - ${start}`;
    } else {
      finalDateString = `${date} - ${start} - ${end}`;
    }

    if (language == "english") return finalDateString;
    else return this.translateDate(finalDateString);
  };

  translateDate = (str) => {
    const ar_months = {
      Jan: "يناير",
      Feb: "فبراير",
      Mar: "مارس",
      Apr: "ابريل",
      May: "مايو",
      Jun: "يونيو",
      Jul: "يوليو",
      Aug: "اغسطس",
      Sep: "سبتمبر",
      Oct: "اكتوبر",
      Nov: "نوفمبر",
      Dec: "ديسمبر",
    };

    const ar_days = {
      Sun: "الأحد",
      Mon: "الاثنين",
      Tue: "الثلاثاء",
      Wed: "الاربعاء",
      Thu: "الخميس",
      Fri: "الجمعة",
      Sat: "السبت",
      Today: "اليوم",
    };

    let temp = str;
    temp = temp.replace("On", "يوم");
    temp = temp.replace(/AM/g, "ص");
    temp = temp.replace(/PM/g, "م");

    Object.keys(ar_months).forEach((key) => {
      if (temp.includes(key)) temp = temp.replace(key, ar_months[key]);
    });
    Object.keys(ar_days).forEach((key) => {
      if (temp.includes(key)) temp = temp.replace(key, ar_days[key]);
    });

    return temp;
  };

  renderAreaName = () => {
    const {
      settings,
      branch,
      address,
      language,
      branches,
      branch_delivery_charges,
      areas,
    } = this.props;
    if (settings.is_branch_based_ordering) {
      if (branch.branch && branch.branch !== -1) {
        if (branch.isPickup) {
          const branchObj = branches.find((b) => b.id === branch.branch);
          if (branchObj)
            return language === "arabic" ? branchObj.ar_name : branchObj.name;
        } else if (branch.bdc && branch.bdc !== -1) {
          const bdcObj = branch_delivery_charges.find(
            (bdc) => bdc.id === branch.bdc,
          );
          if (bdcObj)
            return language === "arabic" ? bdcObj.area_ar : bdcObj.area;
        }
      }
    } else {
      if (address?.selectedDeliveryType === 0 && address?.area) {
        const areaObj = areas.find((a) => a.id === address.area);
        if (areaObj)
          return language === "arabic" ? areaObj.ar_name : areaObj.name;
      } else if (
        address?.selectedDeliveryType === 1 &&
        address?.pickupArea &&
        address?.pickupArea !== -1
      ) {
        const branchObj = branches.find((b) => b.id === address.pickupArea);
        if (branchObj)
          return language === "arabic" ? branchObj.ar_name : branchObj.name;
      }
    }

    // Do store based later

    return -1;
  };

  getDeliverToText = () => {
    const { settings, language, allBookings } = this.props;
    if (settings.is_menu) return language === "arabic" ? "فرع" : "Branch";
    if (allBookings) return language === "arabic" ? "حجز من" : "Booking from";
    if (this.getIsDelivery())
      return language === "arabic" ? "توصيل الى" : "Deliver to";
    return language === "arabic" ? "استلام من" : "Pick up from";
  };

  render() {
    moment.locale("en");
    const { language, settings, address, deliveryTime } = this.props;
    const { addressesDrawerOpen, alertOpen } = this.state;
    const customTexts = settings.custom_texts;
    if (!this.props.store) return <></>;

    const hasOnlinePayments = () => {
      return (
        (settings.enable_tap ||
          settings.enable_tap_v2 ||
          settings.enable_tap_v3_debit ||
          settings.enable_tap_v3_credit ||
          settings.enable_myfatoorah ||
          settings.enable_bookey ||
          settings.enable_hesabe ||
          settings.enable_upay ||
          settings.enable_upay_v2 ||
          settings.enable_ottu ||
          settings.enable_ottu_v2 ||
          settings.enable_tahseeel ||
          settings.enable_ebutler_payment ||
          settings.enable_gatee ||
          settings.enable_tpay ||
          settings.enable_knet ||
          settings.enable_benefit ||
          settings.enable_sadad ||
          settings.enable_sadad_kw ||
          settings.enable_credimax ||
          settings.enable_tamara ||
          settings.enable_tabby ||
          settings.enable_eazypay ||
          settings.enable_payza ||
          settings.enable_paymob ||
          settings.enable_paytabs ||
          settings.enable_ecom ||
          settings.enable_casheer ||
          settings.enable_paystack ||
          settings.enable_ap_gateway ||
          settings.enable_nbk ||
          settings.enable_afs) &&
        settings.enable_payments &&
        settings.enable_online_payments
      );
    };
    const hasCash = () => {
      return settings.enable_cash && settings.allow_cash;
    };

    const showMinOrder = this.props.address
      ? this.props.address.selectedDeliveryType !== 1 ||
        this.props.address.selectedDeliveryType === undefined
      : true;

    const showEditIcon =
      (deliveryTime.scheduled && !deliveryTime.isPickup) ||
      (deliveryTime.pickup &&
        deliveryTime.isPickup &&
        !deliveryTime.asap?.is_international);

    const textRenderDelivery = () => {
      if (
        deliveryTime.type == "asap" &&
        deliveryTime.asap &&
        deliveryTime.asap.now
      ) {
        if (deliveryTime.asap.is_international) {
          if (language == "english")
            return `International shipping within ${parseInt(
              deliveryTime.asap.within / 1440,
            )} days`;
          else
            return `شحن دولي خلال ${parseInt(
              deliveryTime.asap.within / 1440,
            )} يوم`;
        } else
          return this.asapText(deliveryTime.asap.within, deliveryTime.isPickup);
      }

      return this.nonAsapText();
    };

    const callAWaiter = async () => {
      try {
        const res = await instance.post("/customer_at_location/", {
          table_number: address?.token,
        });
        this.setState({ alertOpen: true });
      } catch (e) {
        console.error(e);
      }
    };

    const showLogo =
      settings.show_logo_ar && language !== "english"
        ? settings.show_logo_ar
        : settings.show_logo;

    const showLogoUrl =
      settings.show_logo_ar && language !== "english"
        ? this.props.store.logo_ar
        : this.props.store.logo;

    return (
      <>
        <Drawer
          anchor="bottom"
          classes={{
            paperAnchorBottom: language == "arabic" ? "left-auto" : "",
          }}
          open={deliveryTime.drawerOpen}
          onClose={() => this.props.setDrawer(false)}
          PaperProps={{
            style: { minHeight: 100, height: "auto", width: "100%" },
            className: "text-center",
          }}
          onBackdropClick={() => this.props.setDrawer(false)}
        >
          <DeliveryTimeChange
            applyMarginTopToCloseButton={!showEditIcon}
            text={textRenderDelivery()}
          />
        </Drawer>

        {this.state.callWaiterDialogOpen && (
          <CallWaiterDialog
            onClose={() => this.setState({ callWaiterDialogOpen: false })}
            onClick={() => {
              callAWaiter();
              this.setState({ callWaiterDialogOpen: false });
            }}
            language={language}
          />
        )}
        <Snackbar
          open={alertOpen}
          autoHideDuration={3000}
          onClose={() => this.setState({ alertOpen: false })}
          classes={{ anchorOriginBottomCenter: "snackbar-bottom-70" }}
        >
          <Alert
            onClose={() => this.setState({ alertOpen: false })}
            severity="success"
          >
            {language == "english"
              ? "A waiter has been notified!"
              : "تم ارسال اشعار لموظفي الخدمة"}
          </Alert>
        </Snackbar>

        {this.renderStoreIsBusy()}
        {addressesDrawerOpen && (
          <Addresses
            open={true}
            onClose={() => this.setState({ addressesDrawerOpen: false })}
            comingFrom="serviceTypeSelect"
          />
        )}
        <List
          className={
            !settings.show_cover &&
            !this.checkIfStoreIsBusy() &&
            "product-header-padding"
          }
          style={{
            width: "100%",
            marginTop: 0,
            padding: 0,
            paddingTop: 3,
            backgroundColor: "white",
          }}
        >
          <Link to="/contact" className="makeLinkNormal">
            <ListItem
              button
              alignItems="flex-start"
              className="pt-1"
              disableGutters={true}
              style={{
                flexDirection: this.props.language == "arabic" && "row-reverse",
                marginLeft: 0,
                paddingRight: 0,
                paddingLeft: 15,
                paddingBottom: 4,
              }}
            >
              {showLogo && (
                <ListItemAvatar>
                  <Avatar
                    variant="rounded"
                    src={showLogoUrl}
                    style={{
                      width: 60,
                      height: 60,
                      marginBottom: 9,
                      marginRight: this.props.language == "arabic" && 30,
                    }}
                  />
                </ListItemAvatar>
              )}
              <ListItemText
                primary={
                  <p
                    style={{
                      fontSize: 14,
                      fontWeight: "bold",
                      paddingTop: settings.is_menu && 10,
                    }}
                  >
                    {this.props.language == "english"
                      ? this.props.store.name
                      : this.props.store.ar_name}
                  </p>
                }
                className={
                  this.props.language == "english" ? "ml-3" : "text-right mr-3"
                }
                secondary={
                  <React.Fragment>
                    <Typography
                      component="span"
                      variant="body2"
                      color="textPrimary"
                      style={{ fontSize: "0.9rem", color: "#5f5f5f" }}
                    >
                      {this.props.language == "english"
                        ? this.props.store.slogan
                        : this.props.store.ar_slogan}{" "}
                    </Typography>
                    <Spacer
                      style={{
                        position: "relative",
                        bottom: -5,
                        left: language == "english" && 0,
                        right: language == "arabic" && 0,
                        direction: language == "arabic" ? "rtl" : "ltr",
                        marginTop: 2,
                      }}
                      space={5}
                    >
                      <span order={1}>
                        {!settings.is_menu && (
                          <>
                            {hasOnlinePayments() ||
                            settings.enable_knet_on_delivery ? (
                              <PaymentIcon
                                style={{
                                  color: "#37ad49",
                                  position: "relative",
                                  top: 1,
                                }}
                              />
                            ) : (
                              <span style={{ position: "relative", top: 1 }}>
                                <CancelIcon
                                  style={{
                                    position: "absolute",
                                    width: 12,
                                    height: 12,
                                    top: -3,
                                    color: "#e03333",
                                  }}
                                />
                                <PaymentIcon
                                  style={{
                                    color: "#d2d2d2",
                                  }}
                                />
                              </span>
                            )}
                          </>
                        )}
                      </span>
                      <span order={2}>
                        {!settings.is_menu && (
                          <>
                            {hasCash() ? (
                              <AttachMoneyIcon
                                fill="#37ad49"
                                style={{
                                  color: "#37ad49",
                                  width: 20,
                                  height: 20,
                                }}
                              />
                            ) : (
                              <span
                                style={{
                                  position: "relative",
                                  right: language == "english" && -4,
                                  left: language == "arabic" && -3,
                                  top: 1,
                                }}
                              >
                                <CancelIcon
                                  style={{
                                    position: "absolute",
                                    width: 12,
                                    height: 12,
                                    top: -3,
                                    [language == "english" ? "left" : "right"]:
                                      -4,
                                    color: "#e03333",
                                  }}
                                />
                                <AttachMoneyIcon
                                  fill="#d2d2d2"
                                  style={{
                                    color: "#d2d2d2",
                                    width: 21,
                                    height: 20,
                                    transform: `rotateY(${
                                      language == "english" ? "0" : "180"
                                    }deg)`,
                                  }}
                                />
                              </span>
                            )}
                          </>
                        )}
                      </span>
                      {settings.wheelchair_accessible && !settings.is_menu && (
                        <span order={3}>
                          <AccessibleTwoToneIcon style={{ color: "#37ad49" }} />
                        </span>
                      )}
                      {showMinOrder && !settings.is_menu && (
                        <span
                          order={4}
                          style={{
                            position: "relative",
                            top: 2,
                            fontWeight: "bold",
                            borderRadius: 3,
                            color: "#999",
                          }}
                        >
                          {this.renderMOV()}
                        </span>
                      )}
                    </Spacer>
                  </React.Fragment>
                }
              />

              <ListItemIcon className="" style={{ margin: "auto" }}>
                <InfoOutlinedIcon />
              </ListItemIcon>
            </ListItem>
          </Link>
        </List>
        <div
          style={{
            height: "auto",
            marginTop: 1,
            backgroundColor: "white",
            borderBottomStyle: "solid",
            borderBottomWidth: 1,
            borderBottomColor: "#d4d5d4",
          }}
        >
          {((settings.show_order_mode && !settings.is_menu) ||
            (settings.show_waiting_lists && settings.enable_waiting_lists)) && (
            <ServiceTypeSelect />
          )}
          {((!settings.is_branch_based_ordering && !settings.is_menu) ||
            settings.is_branch_based_ordering) &&
            !this.props.no_address && (
              <div style={{ direction: language === "arabic" ? "rtl" : "ltr" }}>
                {!address?.parkingNumber && !settings.hide_deliver_to && (
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: `15% ${
                        this.getIsDelivery() ? 20 : 25
                      }% auto 16%`,
                      backgroundColor: "white",
                      alignItems: "center",
                      paddingTop: 12,
                      marginBottom: 10,
                    }}
                    onClick={(event) => {
                      if (this.openDeliveryAddressSelector(event)) return;
                      this.props.history.push("/select/branch");
                    }}
                  >
                    <div className="text-center">
                      {settings.is_menu ? (
                        <MenuBookIcon style={{ color: "rgb(173, 173, 173)" }} />
                      ) : this.props.allBookings ? (
                        <LocalLibraryIcon
                          style={{ color: "rgb(173, 173, 173)" }}
                        />
                      ) : (
                        <MotorcycleIcon
                          style={{ color: "rgb(173, 173, 173)" }}
                          className="slide-right"
                        />
                      )}
                    </div>
                    <div
                      className={
                        language === "arabic" ? "text-right" : "text-left"
                      }
                    >
                      {this.getDeliverToText()}
                    </div>
                    <div
                      className={"bold ".concat(
                        language === "arabic" ? "text-left" : "text-right",
                      )}
                      style={{ whiteSpace: "nowrap" }}
                    >
                      {this.props.thirdLoading &&
                      (!this.props.areas.length ||
                        !this.props.areas.find(
                          (a) => a.id === this.props.address?.area,
                        )) &&
                      !settings.is_branch_based_ordering &&
                      this.props.address?.selectedDeliveryType === 0 ? (
                        <span>
                          <CircularProgress
                            color="primary"
                            style={{
                              width: 15,
                              height: 15,
                            }}
                          />
                        </span>
                      ) : (
                        <span>
                          {this.renderAreaName() === -1
                            ? language === "arabic"
                              ? "اختر منطقة"
                              : "Choose location"
                            : this.renderAreaName()}
                        </span>
                      )}
                    </div>
                    <Button
                      color="primary"
                      style={{ textTransform: "none" }}
                      onClick={(e) => {
                        if (this.openDeliveryAddressSelector(e)) return;
                      }}
                    >
                      {language == "english"
                        ? settings.is_branch_based_ordering
                          ? "Edit"
                          : "edit"
                        : "تغيير"}
                    </Button>
                  </div>
                )}
                {((!settings.is_menu &&
                  !this.props.allBookings &&
                  !settings.hide_earliest_arrival) ||
                  address?.parkingNumber) && (
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: address?.parkingNumber
                        ? "15% 30% auto 41px"
                        : "15% 30% auto 16%",
                      backgroundColor: "white",
                      alignItems: "center",
                      paddingBottom: 20,
                      paddingTop:
                        address?.parkingNumber || settings.hide_deliver_to
                          ? 20
                          : 0,
                    }}
                  >
                    <div className="text-center">
                      {!!address?.parkingNumber ? (
                        settings.enable_table_qr ? (
                          <RestaurantMenuIcon
                            style={{ color: "rgb(173, 173, 173)" }}
                          />
                        ) : [
                            "aurapalma.enable.qa",
                            "festivalarenafood.enable.qa",
                          ].includes(window.location.hostname) ? (
                          <LocationOnIcon
                            style={{ color: "rgb(173, 173, 173)" }}
                          />
                        ) : (
                          <LocalParkingIcon
                            style={{ color: "rgb(173, 173, 173)" }}
                          />
                        )
                      ) : (
                        <ScheduleIcon style={{ color: "rgb(173, 173, 173)" }} />
                      )}
                    </div>
                    <div
                      className={
                        language === "arabic" ? "text-right" : "text-left"
                      }
                    >
                      {!!address?.parkingNumber ? (
                        <span>
                          {settings.enable_table_qr
                            ? language === "arabic"
                              ? customTexts.table_number_ar
                              : customTexts.table_number
                            : language === "arabic"
                              ? [
                                  "aurapalma.enable.qa",
                                  "festivalarenafood.enable.qa",
                                ].includes(window.location.hostname)
                                ? "منصة"
                                : customTexts.parking_number_ar
                              : [
                                    "aurapalma.enable.qa",
                                    "festivalarenafood.enable.qa",
                                  ].includes(window.location.hostname)
                                ? "Stand"
                                : customTexts.parking_number}
                        </span>
                      ) : (
                        <span>
                          {this.getIsDelivery()
                            ? language === "arabic"
                              ? customTexts.earliest_arrival_ar
                              : customTexts.earliest_arrival
                            : language === "arabic"
                              ? customTexts.earliest_pickup_ar
                              : customTexts.earliest_pickup}
                        </span>
                      )}
                    </div>
                    <div
                      className={"bold ".concat(
                        this.props.deliveryTime.loading &&
                          !address?.parkingNumber
                          ? "text-center"
                          : language === "arabic"
                            ? "text-left"
                            : "text-right",
                      )}
                    >
                      {!!address?.parkingNumber ? (
                        <span>{address?.parkingNumber}</span>
                      ) : (
                        <div>
                          {this.props.deliveryTime.loading ? (
                            <span>
                              <CircularProgress
                                color="primary"
                                style={{
                                  width: 15,
                                  height: 15,
                                }}
                              />
                            </span>
                          ) : (
                            <div
                              style={{
                                wordBreak: "break-word",
                              }}
                            >
                              {settings.is_branch_based_ordering &&
                              this.renderAreaName() === -1
                                ? ""
                                : this.getDeliveryTimeText() || "-"}
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                    <span>
                      {!this.props.deliveryTime.loading &&
                        !(
                          settings.is_branch_based_ordering &&
                          this.renderAreaName() === -1
                        ) &&
                        showEditIcon &&
                        !address?.parkingNumber && (
                          <Button
                            color="primary"
                            style={{ textTransform: "none" }}
                            onClick={(e) => {
                              showEditIcon && this.props.setDrawer(true);
                            }}
                          >
                            {language == "english"
                              ? settings.is_branch_based_ordering
                                ? "Edit"
                                : "edit"
                              : "تغيير"}
                          </Button>
                        )}
                    </span>
                  </div>
                )}

                {address?.token &&
                  settings.enable_table_qr &&
                  settings.enable_pickup_arrival_requests && (
                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns: "15% auto 100px",
                        backgroundColor: "white",
                        alignItems: "center",
                        paddingBottom: 20,
                        paddingTop: 0,
                      }}
                    >
                      <div></div>
                      <div
                        className={
                          language === "arabic" ? "text-right" : "text-left"
                        }
                      >
                        {language === "arabic"
                          ? "تحتاج الى موظف خدمة؟"
                          : "Need a waiter?"}
                      </div>
                      <div
                        className={
                          language === "arabic" ? "text-right" : "text-left"
                        }
                      >
                        <Button
                          variant="contained"
                          style={{
                            boxShadow: "none",
                            direction: language === "arabic" ? "rtl" : "ltr",
                          }}
                          startIcon={
                            <RoomServiceIcon
                              style={
                                language === "arabic"
                                  ? { position: "relative", right: -10 }
                                  : {}
                              }
                            />
                          }
                          onClick={() =>
                            this.setState({ callWaiterDialogOpen: true })
                          }
                        >
                          {language === "arabic" ? "طلب" : "Call"}
                        </Button>
                      </div>
                    </div>
                  )}
              </div>
            )}
        </div>
      </>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchDeliveryTime: () => dispatch(fetchDeliveryTime()),
    setDrawer: (state) => dispatch(setDrawer(state)),
  };
};
const mapStateToProps = (state) => {
  return {
    language: state.store.language,
    labels: state.store.labels,
    store: state.store.store,
    settings: state.store.store.settings,
    productionSlots: state.store.store.production_slots,
    branch: state.branch,
    address: state.customers.address,
    branch_delivery_charges: state.store.store.branch_delivery_charges,
    branches: state.store.store.branches,
    deliveryTime: state.deliveryTime,
    allow_only_pickup: state.cart.pickup_only_items > 0,
    has_preordering:
      state.cart.preordering_max_leadtime > 0 &&
      state.cart.preordered_items > 0,
    areas: state.store.store.areas,
    thirdLoading: state.store.thirdLoading, //This is for store based to show a spinner on the area name until areas finish loading
    auth: state.auth,
    orderPassAddresses: state.customers.orderPassAddresses || [],
    allBookings: state.store.store.all_bookings,
    no_address: state.store.store.no_address,
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(StoreInfo),
);
